import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";
import { isEmpty } from "ramda";
import PlanOptions from "./PlanOptions";
import { FormattedMessage, injectIntl, intlShape, FormattedHTMLMessage } from "react-intl";
import messages from "components/messagesDescription";
import PlanIntervalOptions from "./PlanIntervalOptions";
import StandardMoney from "../../common/StandardMoney";

const getPriceMode = (isRelativePrice, relativeTagNode) =>
  ({
    [!isRelativePrice]: "absolute",
    [isRelativePrice && relativeTagNode !== "" && relativeTagNode !== "Standard"]: "relative",
    [(isRelativePrice && relativeTagNode === "") || relativeTagNode === "Standard"]: "standard",
  }[true]);

const getIsHDFRequired = plan => {
  const selectedPlanOption =
    plan && plan.options && plan.options.find(selectedOption => selectedOption.isSelected);
  return selectedPlanOption && selectedPlanOption.isHDFRequired
    ? selectedPlanOption.isHDFRequired
    : plan.isHDFRequired;
};

const PlanBox = ({ plan, onChange, showOptions, currency, selectionMode, isAvailable, intl }) => {
  const isHDFRequired = getIsHDFRequired(plan);
  const planPrice =
    plan.options && plan.options.length > 0 && selectionMode !== "individual"
      ? plan.options[0].price
      : plan.price;

  const Component = isAvailable ? "button" : "div";
  const additionalProps = isAvailable
    ? {
        onClick: () => onChange(plan),
        type: "button",
      }
    : {
        disabled: true,
      };

  const componentCls = classnames("product-plan", "product-plan--selectable", {
    "product-plan--with-options": showOptions,
    "product-plan--active": plan.isSelected,
    "product-plan--disabled": !isAvailable,
  });

  const priceMode = getPriceMode(plan.isRelativePrice, plan.relativeTagNode);

  const description = isEmpty(plan.description) ? plan.subDescription : plan.description;
  const subDescription = isEmpty(plan.description) ? null : plan.subDescription;

  return (
    <div
      id={plan.uniqueId}
      key={plan.uniqueId}
      className="grid__item grid__item--three product-panel__plan"
    >
      <div className="product-plan-wrapper">
        <div className="product-plan__badges">
          <div className="product-plan__badge" aria-hidden={!plan.isDefault}>
            <FormattedMessage {...messages.defaultDescription} />
          </div>
          {/* APL-1306 We will cater for recommended when it comes
            <div
              className="product-plan__badge"
              aria-hidden={!plan.isRecommended}
            >
              <FormattedMessage {...messages.recommendedDescription} />
            </div>
          */}
        </div>
        <Component {...additionalProps} className={componentCls}>
          <div className="product-plan__details">
            <div className="product-plan__name" title={plan.description}>
              {/* APL-755 dirty hack to break $100000/visit string .replace(/\//ig, " /") */
              description &&
                intl
                  .formatMessage({
                    id: description,
                    defaultMessage: description,
                  })
                  .replace(/\//gi, " /")}
            </div>

            {subDescription && (
              <p className="product-plan__description">
                {intl
                  .formatMessage({
                    id: subDescription,
                    defaultMessage: subDescription,
                  })
                  .replace(/\//gi, " /")}
              </p>
            )}

            {isHDFRequired && (
              <p className="product-plan__note">
                <FormattedHTMLMessage {...messages.HDFRDescription} />
              </p>
            )}

            {!isAvailable && (
              <p className="product-plan__unavailable">
                <FormattedMessage {...messages.notAvailableDescription} />
              </p>
            )}

            <p id={`${plan.uniqueId}-price`} className="product-plan__price">
              {priceMode === "absolute" ? (
                <div>
                  <FormattedMessage {...messages.priceDescription} />
                  :&nbsp;
                  <StandardMoney value={planPrice} currency={currency} />
                </div>
              ) : priceMode === "relative" ? (
                <div>
                  <FormattedMessage {...messages.relativeTagNode} />
                  :&nbsp;
                  <StandardMoney value={plan.relativePrice} currency={currency} />
                </div>
              ) : (
                <FormattedMessage {...messages.standardDescription} />
              )}
            </p>
          </div>
        </Component>
        <PlanIntervalOptions plan={plan} onChange={onChange} currency={currency} />
        {selectionMode !== "individual" && (
          <PlanOptions
            plan={plan}
            showOptions={showOptions}
            onChange={onChange}
            currency={currency}
          />
        )}
      </div>
    </div>
  );
};

PlanBox.propTypes = {
  plan: PropTypes.object,
  onChange: PropTypes.func,
  showOptions: PropTypes.bool,
  currency: PropTypes.string,
  intl: intlShape.isRequired,
  selectionMode:PropTypes.string,
  isAvailable:PropTypes.bool,
};

export default injectIntl(PlanBox);



// WEBPACK FOOTER //
// ./components/employee/shop/PlanBox.js